export default __webpack_public_path__ + "images/pers_icon_0127acaa60e12d101a48ecc808562d60.svg";